export const selectRestaurants = (state) => {
  return state.restaurants.AllRestaurants;
};

export const selectRestaurantById = (id) => (state) => {
  return state.restaurants.AllRestaurants.find(function (restaurant) {
    return parseInt(restaurant.id) === parseInt(id);
  });
};
